/**
 * Voice persona configuration — single source of truth for who the AI is.
 *
 * Each persona maps to:
 *   - An ElevenLabs Agent ID (set in your ElevenLabs dashboard, supplied via
 *     env var). The agent itself holds the voice + its own internal system
 *     prompt, so make sure the female agent is also female-coded in its prompt.
 *   - A display name shown in the UI ("Job", "Jasmijn").
 *   - Gender / pronouns used when adapting copy (e.g. SYSTEM_PROMPT).
 *
 * If the env var for a persona is missing, that persona is marked available=false
 * and the picker will gray it out — preventing dead toggles.
 */
export const PERSONAS = {
  job: {
    id: 'job',
    name: 'Matcher',
    gender: 'male',
    pronouns: { subject: 'hij', object: 'hem', possessive: 'zijn' },
    agentId: process.env.REACT_APP_ELEVENLABS_AGENT_ID,
    description: 'Mannelijke stem, ervaren en direct',
    available: !!process.env.REACT_APP_ELEVENLABS_AGENT_ID,
  },
  jasmijn: {
    id: 'jasmijn',
    name: 'Jasmijn',
    gender: 'female',
    pronouns: { subject: 'zij', object: 'haar', possessive: 'haar' },
    agentId: process.env.REACT_APP_ELEVENLABS_AGENT_ID_FEMALE,
    description: 'Vrouwelijke stem, warm en helder',
    available: !!process.env.REACT_APP_ELEVENLABS_AGENT_ID_FEMALE,
  },
};

export const DEFAULT_PERSONA_ID = 'job';

/** Get persona by id with fallback to default. Never returns null. */
export function getPersona(personaId) {
  return PERSONAS[personaId] || PERSONAS[DEFAULT_PERSONA_ID];
}
